import React from 'react'
import styled from 'styled-components'
import Link from '../../routes/Link';
import { Column, Logo, RootContainer, FlexContainer } from '../../common'
import { MediaListener } from '../../utils'

const Separator = styled.div`
  border-left: 1px solid #eaeaea;
  width: 1px;
  margin: 0px 27px;
`
const AuthWrapper = ({ children }) => (
    <RootContainer align='center' justify='center'>
        <MediaListener values={['row', 'row', 'column']} defaultValue='column' >
            {({ currentValue }) => (
                <FlexContainer direction={currentValue} flex='1' style={{ maxHeight: 1024, maxWidth: 728, padding: 20 }}>
                    <Column justify='center' flex='1' style={currentValue === 'column' ? { borderBottom: '1px solid #eaeaea', marginBottom: '20px' } : {}}>
                        <Link href='/' >
                            <Logo style={{ minHeight: '60px', display: 'flex', justifyContent: 'center' }} />
                        </Link>
                    </Column>
                    <Separator />
                    <Column flex='1'>
                        {children}
                    </Column>
                </FlexContainer>
            )}
        </MediaListener>
    </RootContainer>
)

export const RequestErrorWrapper = styled(FlexContainer)`
  color: #cc182e;
`

export default AuthWrapper
